import type { GetAdCopySimulationV3Response } from "../../../../../../../server/types/request/ad-copy/report/v3/simulation";
import type { AdCopySimulationLatestAction } from "../../../../../types/actions";
import type { MessageInfo } from "../../../../../types/info";

type State = Omit<
	GetAdCopySimulationV3Response,
	"constant" | "referenceSourceData" | "job" | "activity" | "evaluation"
> &
	Partial<
		Pick<GetAdCopySimulationV3Response, "constant" | "referenceSourceData" | "job" | "activity" | "evaluation">
	> & {
		confirmMessage: string | undefined;
		info: MessageInfo;
		loading: boolean;
	};

export const initState: State = {
	confirmMessage: undefined,
	goalSalesVolume: 0,
	info: {
		isSuccess: true,
		message: "",
	},
	goalRecognitionRate: 0,
	loading: true,
	maxRecognition: 0,
	simulationPredictionData: {},
};

export const reducer = (state: State, action: AdCopySimulationLatestAction): State => {
	switch (action.type) {
		case "loadData":
			return {
				...state,
				confirmMessage: undefined,
				loading: false,
				...action.payload,
			};

		case "updateData":
			return {
				...state,
				confirmMessage: undefined,
				loading: false,
				...action.payload,
				info: { isSuccess: true, message: "保存が完了しました。" },
			};

		case "clearCPData":
			return {
				...state,
				confirmMessage: undefined,
				loading: false,
				...action.payload,
				info: {
					isSuccess: true,
					message: "実績値修正のクリアが完了しました。",
				},
			};

		case "changeRatio": {
			const { name, target, value } = action.payload;

			return {
				...state,
				confirmMessage: "保存せずにページを移動すると入力内容がクリアされます。移動してよろしいでしょうか。",
				simulationPredictionData: {
					...state.simulationPredictionData,
					[target]: {
						...state.simulationPredictionData[target],
						correctionValue: {
							...state.simulationPredictionData[target]?.correctionValue,
							[name]: value,
						},
					},
				},
			};
		}

		case "changeCP": {
			return {
				...state,
				confirmMessage:
					"CP値を入力し、推計値算出まで実施しないとCP実績補整は提案フォーマットに反映されません。\n移動してよろしいでしょうか。",
				currentProduct: {
					...state.currentProduct,
					correctionValue: {
						...state.currentProduct?.correctionValue,
						[action.payload.name]: action.payload.value,
					},
				},
			};
		}

		case "changeMessageInfo":
			return {
				...state,
				info: action.payload,
				loading: false,
			};

		case "downloadSimulation":
			return {
				...state,
				confirmMessage: undefined,
				loading: false,
			};

		case "saveSimulation":
			return {
				...state,
				confirmMessage: action.payload.isSuccess ? undefined : state.confirmMessage,
				info: action.payload,
				loading: false,
			};

		case "setChanged":
			return {
				...state,
				confirmMessage: action.payload ? state.confirmMessage : undefined,
			};

		case "changeLoading":
			return { ...state, loading: action.payload };
	}
};
